// extracted by mini-css-extract-plugin
module.exports = {"prefix":"Prefix--prefix--Wg4-A","icon":"Prefix--icon--3btOL","disabled":"Prefix--disabled--2c1sW"};